import styled from '@emotion/styled/macro';

export const TableLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0 30px;
  a {
    font-weight: 700;
    font-size: ${14 / 16}rem;
    color: var(--brand-primary);
  }
`;
